import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const dashboard_tile_action: EventDefinition = {
  getData: (_, eventData) => ({
    type: eventData?.dashboardTile.type,
  }),
  addContexts: ({ eventData } = {}) => {
    if (!eventData) return [];

    const { board } = eventData;

    return createContexts(['board'], {
      eventData: {
        board: {
          id: board.id,
          idType: board.idType,
          viewOrder: board.viewOrder,
          rowOrder: board.rowOrder,
          readBadge: board.readBadge,
        },
      },
    });
  },
};
